/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Playbar_And_HighlightingInputs */

const en_common_playbar_and_highlighting = /** @type {(inputs: Common_Playbar_And_HighlightingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playbar & Highlighting`)
};

const es_common_playbar_and_highlighting = /** @type {(inputs: Common_Playbar_And_HighlightingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducción y resaltado`)
};

/**
* | output |
* | --- |
* | "Playbar & Highlighting" |
*
* @param {Common_Playbar_And_HighlightingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_playbar_and_highlighting = /** @type {((inputs?: Common_Playbar_And_HighlightingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Playbar_And_HighlightingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_playbar_and_highlighting(inputs)
	return en_common_playbar_and_highlighting(inputs)
});